import React, {createContext, useState, useRef, useContext} from 'react';
import LoadingModal from '../components/modules/LoadingModal';
import {Platform} from 'react-native';
import EligibilityStatusModal from '../components/modules/EligibilityStatusModal';
import {storeData} from '../utils/GeneralStorage';
import {KEYS} from '../utils/Constants';
import {CommonActions} from '@react-navigation/native';
import ErrorModal from '../components/modules/ErrorModal';
import {fetchApi} from '../utils/ApiHelper';
import {CHECK_ELIGIBILTY, HTTP_METHODS} from '../utils/URLConstants';
import {accountStatusContext} from './AccountStatusContext';
import moment from 'moment';

export const eligibilityCheckContext = createContext();
const {Provider} = eligibilityCheckContext;

const EligibilityCheckContext = props => {
  const [showLoader, setShowLoader] = useState(false);
  const [isEligible, setIsEligible] = useState(true);
  const [showPopUp, setShowPopup] = useState(false);
  const [previousScreen, setPreviousScreen] = useState('');
  const [showError, setShowError] = useState(false);
  const navigationRef = useRef();
  const asc = useContext(accountStatusContext);

  async function checkEligibilty(
    navigation,
    name,
    email,
    dateOfBirth,
    subscriberId,
    realtimeFlowId,
  ) {
    try {
      setNavigationRef(navigation);

      // Motiv eligibility checks removed - auto-approve all users
      await makeEligible();
      asc.getUserAccountStatus(setShowLoader);
    } catch (err) {
      // If any error occurs, still make user eligible
      await makeEligible();
    }
  }

  async function makeEligible() {
    await storeLastCheckTime();
    await storeData(KEYS.userEligible, 'true');
    setIsEligible(true);
    setShowLoader(false);
  }

  async function showErrorPopup() {
    await storeLastCheckTime();
    setShowLoader(false);
    setShowError(true);
    await storeData(KEYS.userEligible, 'false');
  }

  async function storeLastCheckTime() {
    await storeData(KEYS.lastEligibilityCheckTime, moment().toISOString());
  }

  const onClose = async () => {
    setIsEligible(false);
    setShowError(false);
  };

  const redirectToHome = () => {
    setShowPopup(false);
    if (previousScreen !== 'SignupPhoneVerification') {
      if (Platform.OS === 'web') {
        navigationRef.current('/home', {replace: true});
      } else {
        navigationRef.current.dispatch(
          CommonActions.reset({
            index: 0,
            routes: [{name: 'HomeTab'}],
          }),
        );
      }
    } else {
      setPreviousScreen('');
    }
  };

  const showPopupOnInEligibility = navigation => {
    setNavigationRef(navigation);
    if (!showLoader && !showError && !isEligible) setShowPopup(true);
  };

  const setNavigationRef = navigation => {
    navigationRef.current = navigation;
  };

  return (
    <>
      <Provider
        value={{
          checkEligibilty,
          setIsEligible,
          isEligible,
          showPopupOnInEligibility,
          setPreviousScreen,
          showLoader,
        }}>
        <>
          {props.children}
          {showLoader && <LoadingModal showCloseLoader={false} />}
          {showPopUp && (
            <EligibilityStatusModal
              visible={showPopUp}
              onPressClose={redirectToHome}
            />
          )}
          {showError && (
            <ErrorModal
              visible={showError}
              message={
                'We are checking your eligibility with your provider. We have contacted the support team to confirm your status. In the meantime you will have a limited view of the app.'
              }
              onClose={onClose}
              buttonTitle="Continue"
            />
          )}
        </>
      </Provider>
    </>
  );
};

export default EligibilityCheckContext;
